// import React, { useState, useEffect } from 'react';
// import {
//     Box,
//     Card,
//     CardContent,
//     Typography,
//     Grid,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     TablePagination,
//     Modal,
//     Chip,
//     CardActionArea,
//     CircularProgress,
//     Paper, 
//     Snackbar, 
//     Alert, 
// } from '@mui/material';
// import {
//     Assignment,
//     CheckCircle,
//     HourglassEmpty,
//     Loop,
//     Warning,
//     Task,
//     Work,
//     CalendarToday as CalendarTodayIcon,
//     Event as EventIcon,
//     PriorityHigh as PriorityHighIcon,
//     Info as InfoIcon,
// } from '@mui/icons-material';
// import axios from 'axios';
// import { localAxiosGet } from '../../Axios/axios';
// import TaskDetails from './TaskDetails';

// const statusBackgroundColors = {
//     total: '#e3f2fd',
//     completed: '#e8f5e9',
//     pending: '#fff3e0',
//     inProgress: '#e3f2fd',
//     overdue: '#ffebee',
// };

// const priorityColors = {
//     High: 'error',
//     Medium: 'warning',
//     Low: 'success',
// };

// const statusColors = {
//     'In Progress': 'warning',
//     Pending: 'error',
//     Completed: 'success',
//     Overdue: 'error',
// };

// const stripedStyle = {
//     '&:nth-of-type(odd)': {
//         backgroundColor: '#ffffff',
//     },
//     '&:nth-of-type(even)': {
//         backgroundColor: '#f5f5f5',
//     },
// };

// function calculateTaskMetrics(tasks) {
//     const today = new Date();
//     let total = tasks.length;
//     let completed = 0;
//     let pending = 0;
//     let overdue = 0;
//     let inProgress = 0;

//     tasks.forEach((task) => {
//         const deadlineDate = new Date(task.due_date || task.deadline);
//         const status = task.status;

//         switch (status) {
//             case "Completed":
//                 completed++;
//                 break;
//             case "In Progress":
//                 inProgress++;
//                 if (deadlineDate < today) {
//                     overdue++;
//                 }
//                 break;
//             case "Pending":
//                 pending++;
//                 if (deadlineDate < today) {
//                     overdue++;
//                 }
//                 break;
//             case "Overdue":
//                 overdue++;
//                 break;
//             default:
//                 pending++;
//                 if (deadlineDate < today) {
//                     overdue++;
//                 }
//                 break;
//         }
//     });

//     return {
//         total,
//         completed,
//         inProgress,
//         pending,
//         overdue,
//     };
// }

// const MyTasks = () => {
//     const [filter, setFilter] = useState('all');
//     const [page, setPage] = useState(0);
//     const [rowsPerPage, setRowsPerPage] = useState(6);
//     const userId = localStorage.getItem('userId');
//     const [tasks, setTasks] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [selectedTask, setSelectedTask] = useState(null);
//     const [isTaskDetailsOpen, setIsTaskDetailsOpen] = useState(false);
//     const [snackbarOpen, setSnackbarOpen] = useState(false);
//     const [snackbarMessage, setSnackbarMessage] = useState('');
//     const [snackbarSeverity, setSnackbarSeverity] = useState('error'); 
//     const [sortOption, setSortOption] = useState('newest'); 


//     const sortTasksByDate = (tasks) => {
//         return [...tasks].sort((a, b) => {

//             const dateA = a.created_at ? new Date(a.created_at) : new Date(a.start_date);
//             const dateB = b.created_at ? new Date(b.created_at) : new Date(b.start_date);
//             return dateB - dateA; 
//         });
//     };


//     const handleChangePage = (event, newPage) => {
//         setPage(newPage);
//     };


//     const handleChangeRowsPerPage = (event) => {
//         setRowsPerPage(parseInt(event.target.value, 10));
//         setPage(0);
//     };


//     const getFilteredAndSortedTasks = () => {
//         const filtered = tasks.filter((task) => {
//             if (filter === 'all') return true;
//             if (filter === 'Overdue') return task.status === 'Overdue';
//             return task.status === filter;
//         });


//         return sortTasksByDate(filtered);
//     };

//     const filteredTasks = getFilteredAndSortedTasks();


//     const displayedTasks = filteredTasks.slice(
//         page * rowsPerPage,
//         page * rowsPerPage + rowsPerPage
//     );

//     useEffect(() => {        
//         fetchTasks();
//     }, [userId]); 

//     const fetchTasks = async () => {
//         try {
//             setLoading(true);
//             const response = await axios(localAxiosGet(`/task/getAllTasksByEmployeeId/${userId}`));
//             if (response.data.status === "SUCCESS") {

//                 const formattedTasks = response.data.tasks.map(task => ({
//                     ...task,
//                     created_at: task.created_at || task.start_date 
//                 }));


//                 const sortedTasks = sortTasksByDate(formattedTasks);
//                 setTasks(sortedTasks);
//             } else {
//                 setError("Failed to fetch tasks");
//                 setSnackbarMessage(response.data.message || "Failed to fetch tasks");
//                 setSnackbarOpen(true);
//                 setSnackbarSeverity('error');
//             }
//         } catch (err) {
//             setError("Error fetching tasks: " + err.message);
//             setSnackbarMessage("Error fetching tasks: " + err.message);
//             setSnackbarOpen(true);
//             setSnackbarSeverity('error');
//             console.error("Error fetching tasks:", err);
//         } finally {
//             setLoading(false);
//         }
//     };


//     const addNewTask = (newTask) => {

//         const formattedNewTask = {
//             ...newTask,
//             created_at: newTask.created_at || new Date().toISOString(),
//         };


//         setTasks([formattedNewTask, ...tasks]);
//     };


//     const taskMetrics = calculateTaskMetrics(tasks);

//     const handleTaskDetailsClick = (task) => {
//         setSelectedTask(task);
//         setIsTaskDetailsOpen(true);
//     };

//     const handleCloseTaskDetails = () => {
//         setIsTaskDetailsOpen(false);
//         setSelectedTask(null);
//         fetchTasks(); 
//     };


//     const handleTaskUpdated = (updatedTask) => {
//         setTasks(prevTasks => {
//             const updatedTasks = prevTasks.map(task => 
//                 task.id === updatedTask.id ? { ...task, ...updatedTask } : task
//             );
//             return sortTasksByDate(updatedTasks);
//         });
//     };

//     const handleSnackbarClose = (event, reason) => {
//         if (reason === 'clickaway') {
//             return;
//         }
//         setSnackbarOpen(false);
//     };

//     if (loading) {
//         return (
//             <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
//                 <CircularProgress />
//             </Box>
//         );
//     }

//     return (
//         <Box sx={{ mt: 4 }}>

//             <Grid container spacing={2} sx={{ mb: 4 }}>
//                 {[
//                     { label: 'Total', count: taskMetrics.total, color: 'default', icon: Assignment, filter: 'all' },
//                     { label: 'Completed', count: taskMetrics.completed, color: 'green', icon: CheckCircle, filter: 'Completed' },
//                     { label: 'ToDo', count: taskMetrics.pending, color: 'orange', icon: HourglassEmpty, filter: 'Pending' },
//                     { label: 'In Progress', count: taskMetrics.inProgress, color: 'blue', icon: Loop, filter: 'In Progress' },
//                     { label: 'Overdue', count: taskMetrics.overdue, color: 'red', icon: Warning, filter: 'Overdue' },
//                 ].map((metric, index) => (
//                     <Grid
//                         item
//                         xs={12}
//                         md={3}
//                         key={index}
//                         sx={{
//                             transition: 'transform 0.3s ease-in-out',
//                             '&:hover': {
//                                 transform: 'scale(1.05)',
//                             },
//                         }}
//                     >
//                         <Card
//                             sx={{ bgcolor: statusBackgroundColors[metric.label.toLowerCase().replace(' ', '')], cursor: 'pointer' }}
//                             onClick={() => {
//                                 setFilter(metric.filter);
//                                 setPage(0);
//                             }}
//                         >
//                             <CardActionArea onClick={() => setFilter(metric.filter)}>
//                                 <CardContent>
//                                     <Box display="flex" flexDirection="column" alignItems="flex-start">
//                                         <metric.icon sx={{ fontSize: 40, mb: 1, color: metric.color }} />
//                                         <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                                             {metric.label}
//                                         </Typography>
//                                         <Typography variant="h4" color={metric.color}>
//                                             {metric.count}
//                                         </Typography>
//                                     </Box>
//                                 </CardContent>
//                             </CardActionArea>
//                         </Card>
//                     </Grid>
//                 ))}
//             </Grid>
//             {/* Task Table */}
//             <Typography variant="h5" sx={{ fontWeight: '600' }} gutterBottom>
//                 {`${filter.charAt(0).toUpperCase() + filter.slice(1)} Tasks`}
//             </Typography>
//             <TableContainer component={Paper}>
//                 <Table>
//                     <TableHead>
//                         <TableRow sx={{
//                             background: 'linear-gradient(to right, #a8fdf5, #fff)',
//                         }}>
//                             <TableCell sx={{ fontWeight: 'bold' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <Task sx={{ mr: 1, color: 'primary.main' }} />
//                                     Task Name
//                                 </Box>
//                             </TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <Work sx={{ mr: 1, color: 'primary.main' }} />
//                                     Project Name
//                                 </Box>
//                             </TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <CalendarTodayIcon sx={{ mr: 1, color: 'secondary.main' }} />
//                                     Assigned Date
//                                 </Box>
//                             </TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <EventIcon sx={{ mr: 1, color: 'error.main' }} />
//                                     Deadline
//                                 </Box>
//                             </TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <PriorityHighIcon sx={{ mr: 1, color: 'warning.main' }} />
//                                     Priority
//                                 </Box>
//                             </TableCell>
//                             <TableCell sx={{ fontWeight: 'bold' }}>
//                                 <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                                     <InfoIcon sx={{ mr: 1, color: 'info.main' }} />
//                                     Status
//                                 </Box>
//                             </TableCell>
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {displayedTasks.length > 0 ? (
//                             displayedTasks.map((task, index) => (
//                                 <TableRow
//                                     key={index}
//                                     sx={stripedStyle}
//                                     onClick={() => handleTaskDetailsClick(task)}
//                                     style={{ cursor: 'pointer' }}
//                                 >
//                                     <TableCell sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
//                                         {task.task_title}
//                                     </TableCell>
//                                     <TableCell sx={{ fontWeight: '600', fontSize: '1rem' }}>
//                                         {task.project_name}
//                                     </TableCell>
//                                     <TableCell>{new Date(task.start_date).toLocaleDateString()}</TableCell>
//                                     <TableCell>{new Date(task.due_date).toLocaleDateString()}</TableCell>
//                                     <TableCell>
//                                         <Chip
//                                             label={task.priority}
//                                             color={priorityColors[task.priority]}
//                                             variant="contained"
//                                         />
//                                     </TableCell>
//                                     <TableCell>
//                                         <Chip
//                                             label={task.status}
//                                             color={statusColors[task.status] || 'default'}
//                                             variant="contained"
//                                         />
//                                     </TableCell>
//                                 </TableRow>
//                             ))
//                         ) : (
//                             <TableRow>
//                                 <TableCell colSpan={6} align="center">
//                                     No tasks found
//                                 </TableCell>
//                             </TableRow>
//                         )}
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//             <TablePagination
//                 component="div"
//                 count={filteredTasks.length}
//                 page={page}
//                 onPageChange={handleChangePage}
//                 rowsPerPage={rowsPerPage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
//                 rowsPerPageOptions={[6, 12, 24]}
//             />
//             <Modal
//                 open={isTaskDetailsOpen}
//                 onClose={handleCloseTaskDetails}
//                 aria-labelledby="task-details-modal-title"
//                 aria-describedby="task-details-modal-description"
//             >
//                                 <Box sx={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%)',
//                     width: '100%',
//                     maxWidth: 1200,
//                     bgcolor: 'background.paper',
//                     borderRadius: '4px',
//                     boxShadow: 24,
//                     p: 3,
//                     maxHeight: '90vh',
//                     overflow: 'auto'
//                 }}>
//                     {selectedTask && (
//                         <TaskDetails
//                             selectedTask={selectedTask}
//                             onClose={handleCloseTaskDetails}
//                             onTaskUpdated={handleTaskUpdated}
//                         />
//                     )}
//                 </Box>
//             </Modal>
//             <Snackbar
//                 open={snackbarOpen}
//                 autoHideDuration={6000} 
//                 onClose={handleSnackbarClose}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} 
//             >
//                 <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
//                     {snackbarMessage}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// };

// export default MyTasks;
import React, { useState, useEffect, useRef } from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Modal,
    Chip,
    CardActionArea,
    CircularProgress, FormControl, InputLabel, Select, MenuItem,
    Paper,
    Snackbar,
    Alert, Button, IconButton, Pagination
} from '@mui/material';
import {
    Assignment,
    CheckCircle,
    HourglassEmpty,
    Loop,
    Warning,
    Task,
    Work,
    AccessTime as AccessTimeIcon,
    CalendarToday as CalendarTodayIcon,
    Event as EventIcon,
    PriorityHigh as PriorityHighIcon,
    Info as InfoIcon, CheckCircle as CheckCircleIcon, Send as SendIcon, Task as TaskIcon,
    Launch as LaunchIcon,
    HourglassEmpty as HourglassEmptyIcon
} from '@mui/icons-material';

import axios from 'axios';
import { localAxiosGet } from '../../../Axios/axios';
import TaskDetails from '../../../components/TaskDetails';
import TokenExpirePopup from '../../../components/TokenExpirePopup';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../../components/loade';
import { useMediaQuery } from '@mui/material';



const priorityBackgroundColors = {
    High: 'rgba(244, 67, 54 )',
    Medium: 'rgba(255, 152, 0)',
    Low: 'rgba(76, 175, 80)',
};

const priorityTextColors = {
    High: '#fff',
    Medium: '#fff',
    Low: '#fff',
};

const statusBackgroundColors = {
    'Open': 'rgba(3, 169, 244, 0.1)',
    'In Progress': 'rgba(59, 130, 246, 0.1)',
    // 'Submit For Review': 'rgba(255, 159, 0, 0.1)',
    'Completed': 'rgba(34, 197, 94, 0.1)',
    'Re Open': 'rgba(156, 39, 176, 0.1)',
    'Hold': 'rgba(158, 158, 158, 0.1)',
    'Overdue': 'rgba(239, 68, 68, 0.1)'
};

const statusTextColors = {
    'Open': '#03a9f4',
    'In Progress': '#3b82f6',
    // 'Submit For Review': '#ff9f00',
    'Completed': '#22c55e',
    'Re Open': '#9c27b0',
    'Hold': '#757575',
    'Overdue': '#ef4444'
};

const formatTime = (hoursDecimal) => {
    if (hoursDecimal === null || hoursDecimal === undefined || hoursDecimal === '') {
        return '--:--';
    }
   
    const totalMinutes = hoursDecimal * 60;
    let hours = Math.floor(totalMinutes / 60);
    let minutes = Math.round(totalMinutes % 60);

    // Handle case where minutes round up to 60
    if (minutes === 60) {
        hours += 1;
        minutes = 0;
    }

    return `${hours} hrs ${minutes.toString().padStart(2, '0')} mins`;
}

const MyTasks = () => {
    const [selectedStatus, setSelectedStatus] = useState('total_task_count')
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const userId = localStorage.getItem('userId');
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedTask, setSelectedTask] = useState(null);
    const [isTaskDetailsOpen, setIsTaskDetailsOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('error');
    const accessToken = localStorage.getItem('accessToken');
    const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
    const navigate = useNavigate();
    const [submittedForReview, setSubmittedForReview] = useState('all')
    const [allReviewTasks, setAllReviewTasks] = useState([]);
    const isLargeScreen = useMediaQuery('(min-width:1100px)');
    const [tasksCounts, setTasksCounts] = useState({
        total_task_count: 0,
        open: 0,
        in_progress: 0,
        submit_for_review: 0,
        completed: 0,
        re_open: 0,
        hold: 0,
        overdue: 0
    });

    const [pagination, setPagination] = useState({
        page: 1,
        limit: rowsPerPage,
        totalPages: 1,
    });

    // Use ref to force re-fetch when submittedForReview changes
    const prevSubmittedForReview = useRef(submittedForReview);

    const fetchTasks = async () => {
        try {
            setLoading(true);

            let statusParam = '';
            if (selectedStatus === 'total_task_count') {
                statusParam = '';
            } else {
                statusParam = `status=${selectedStatus}`;
            }
            let pageParam = '';
            let limitParam = '';
            let submittedForReviewParam = '';

            // For submit_for_review filter: fetch all tasks without pagination
            if (submittedForReview !== 'all') {
                // Convert string to boolean
                const reviewValue = submittedForReview === 'true';
                submittedForReviewParam = `submit_for_review=${reviewValue}`;
                limitParam = `limit=10000`; // Large number to get all tasks
            } else {
                // For normal filtering: use server-side pagination
                pageParam = `page=${pagination.page}`;
                limitParam = `limit=${rowsPerPage}`;
            }

            const queryString = [statusParam, submittedForReviewParam, pageParam, limitParam]
                .filter(Boolean)
                .join('&');

            const apiUrl = `/task/getAllTasksByEmployeeId/${userId}?${queryString}`;

            console.log('API Call:', apiUrl);
            console.log('submittedForReview:', submittedForReview);

            const response = await axios(localAxiosGet(apiUrl, accessToken));

            if (response.data.status === "SUCCESS") {
                const tasksData = response.data.message.tasks;

                // Update task counts
                setTasksCounts({
                    total_task_count: response.data.message.status_counts.total_task_count,
                    open: response.data.message.status_counts.Open,
                    in_progress: response.data.message.status_counts["In Progress"],
                    completed: response.data.message.status_counts.Completed,
                    re_open: response.data.message.status_counts["Re Open"],
                    hold: response.data.message.status_counts.Hold,
                    overdue: response.data.message.status_counts.Overdue
                });

                // Handle submit_for_review filter with client-side pagination
                if (submittedForReview !== 'all') {
                    setAllReviewTasks(tasksData);

                    // Calculate client-side pagination
                    const startIndex = (pagination.page - 1) * rowsPerPage;
                    const endIndex = startIndex + rowsPerPage;
                    const paginatedTasks = tasksData.slice(startIndex, endIndex);
                    setTasks(paginatedTasks);

                    const totalPages = Math.ceil(tasksData.length / rowsPerPage);
                    setPagination(prev => ({
                        ...prev,
                        totalPages: totalPages || 1,
                    }));
                } else {
                    // Normal server-side pagination
                    setTasks(tasksData);
                    setAllReviewTasks([]);
                    setPagination(prev => ({
                        ...prev,
                        totalPages: response.data.message.totalPages || 1,
                    }));
                }
            } else {
                setError("Failed to fetch tasks");
                setSnackbarMessage(response.data.message || "Failed to fetch tasks");
                setSnackbarOpen(true);
                setSnackbarSeverity('error');
                setTasks([]);
                setAllReviewTasks([]);
                setTasksCounts({
                    total_task_count: 0, open: 0, in_progress: 0,
                    completed: 0, re_open: 0, hold: 0, overdue: 0
                });
                setPagination({
                    page: 1, limit: rowsPerPage, totalPages: 1
                });
            }
        } catch (err) {
            setError("Error fetching tasks: " + err.message);
            setSnackbarMessage("Error fetching tasks: " + err.message);
            setSnackbarOpen(true);
            setSnackbarSeverity('error');
            console.error("Error fetching tasks:", err);
            setTasks([]);
            setAllReviewTasks([]);
            setTasksCounts({
                total_task_count: 0, open: 0, in_progress: 0,
                completed: 0, re_open: 0, hold: 0, overdue: 0
            });
            setPagination({
                page: 1, limit: rowsPerPage, totalPages: 1
            });
            if (err.response && err.response.status === 403) {
                setOpenTokenExpirePopup(true);
            }
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 1000);
        }
    };

    // Main useEffect - triggers API call whenever dependencies change
    useEffect(() => {
        // Check if submittedForReview actually changed
        const reviewChanged = prevSubmittedForReview.current !== submittedForReview;

        if (reviewChanged) {
            // Reset to page 1 when submit_for_review changes
            setPagination(prev => ({ ...prev, page: 1 }));
            prevSubmittedForReview.current = submittedForReview;
        }

        fetchTasks();
    }, [userId, selectedStatus, submittedForReview, accessToken]);

    // Separate useEffect for pagination changes (only for server-side pagination)
    useEffect(() => {
        if (submittedForReview === 'all') {
            fetchTasks();
        } else {
            // Client-side pagination
            if (allReviewTasks.length > 0) {
                const startIndex = (pagination.page - 1) * rowsPerPage;
                const endIndex = startIndex + rowsPerPage;
                setTasks(allReviewTasks.slice(startIndex, endIndex));
            }
        }
    }, [pagination.page, rowsPerPage]);

    const cardsData = [
        { label: 'Total', count: tasksCounts.total_task_count, icon: <Assignment />, color: "#2196F3", statusFilter: 'total_task_count', labelColor: '#1a237e', countColor: '#1a237e' },
        { label: 'Completed', count: tasksCounts.completed, icon: <CheckCircle />, color: "#35f921", statusFilter: 'Completed', labelColor: '#1b5e20', countColor: '#1b5e20' },
        { label: 'Open', count: tasksCounts.open, icon: <LaunchIcon />, color: "#00f1f5", statusFilter: 'Open', labelColor: '#006064', countColor: '#006064' },
        { label: 'Overdue', count: tasksCounts.overdue, icon: <Warning />, color: "#f44336", statusFilter: 'Overdue', labelColor: '#b71c1c', countColor: '#b71c1c' },
    ]

    const handleCardClick = (status) => {
        setSelectedStatus(status);
        setPagination(prev => ({ ...prev, page: 1 }));
        setRowsPerPage(10);

        if (submittedForReview !== 'all') {
            setAllReviewTasks([]);
        }
    }

    const handleTaskDetailsClick = (taskId) => {
        setSelectedTask(taskId);
        setIsTaskDetailsOpen(true);
    };

    const handlePageChange = (event, newPage) => {
        setPagination(prev => ({ ...prev, page: newPage }));

        if (submittedForReview !== 'all' && allReviewTasks.length > 0) {
            const startIndex = (newPage - 1) * rowsPerPage;
            const endIndex = startIndex + rowsPerPage;
            setTasks(allReviewTasks.slice(startIndex, endIndex));
        }
    };

    const handleRowsPerPageChange = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);

        if (submittedForReview !== 'all' && allReviewTasks.length > 0) {
            const startIndex = 0;
            const endIndex = newRowsPerPage;
            setTasks(allReviewTasks.slice(startIndex, endIndex));
            const totalPages = Math.ceil(allReviewTasks.length / newRowsPerPage);

            setPagination({
                page: 1,
                limit: newRowsPerPage,
                totalPages: totalPages || 1
            });
        } else {
            setPagination(prev => ({ ...prev, page: 1, limit: newRowsPerPage }));
        }
    };

    const handleCloseTaskDetails = () => {
        setIsTaskDetailsOpen(false);
        setSelectedTask(null);
        fetchTasks();
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleCloseTokenExpirePopup = () => {
        setOpenTokenExpirePopup(false);
        navigate('/');
    };

    const allStatuses = [
        { label: 'All', value: 'total_task_count' },
        { label: 'Open', value: 'Open' },
        { label: 'In Progress', value: 'In Progress' },
        { label: 'Completed', value: 'Completed' },
        { label: 'Re-Open', value: 'Re-Open' },
        { label: 'Hold', value: 'Hold' },
        { label: 'Overdue', value: 'Overdue' },
    ];

    const handleFilterChange = (event) => {
        const newStatus = event.target.value;
        setSelectedStatus(newStatus);
        setPagination(prev => ({ ...prev, page: 1 }));

        if (submittedForReview !== 'all') {
            setAllReviewTasks([]);
        }
    };

    const handleSubmittedForReviewChange = (event) => {
        const newValue = event.target.value;
        console.log('Submit for review changed to:', newValue);
        setSubmittedForReview(newValue);
        setAllReviewTasks([]);
        setPagination({ page: 1, limit: rowsPerPage, totalPages: 1 });
    }

    const formatCustomTimeDisplay = (customTimeValue) => {
        if (customTimeValue === null || customTimeValue === undefined || customTimeValue === '') {
            return '--:--';
        }

        const [hoursStr, minutesStrRaw = '0'] = customTimeValue.toString().split('.');
        const hours = parseInt(hoursStr, 10);
        const minutes = parseInt(minutesStrRaw.padEnd(2, '0'), 10);

        if (isNaN(hours) || isNaN(minutes)) {
            return '--:--';
        }
        return `${hours} hrs ${minutes.toString().padStart(2, '0')} mins`;
    };

    return (
        <>
            {loading && <Loader />}
            <Box sx={{ mt: 4, mr: 3, minHeight: '75vh' }}>
                <Typography variant="h4" fontWeight="bold" marginBottom={2} >
                    My Tasks
                </Typography>
                <Grid container spacing={3}>
                    {cardsData.map((metric, index) => (
                        <Grid item xs={6} md={4} lg={3} key={index} mt={2}>
                            <Card
                                onClick={() => handleCardClick(metric.statusFilter)}
                                sx={{
                                    background: `linear-gradient(to right, ${metric.color}33, ${metric.color}11)`,
                                    boxShadow: 3,
                                    padding: 2,
                                    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        transform: 'scale(1.01)',
                                        boxShadow: '0px 0px 20px rgba(0,0,0,0.3)',
                                        zIndex: 1,
                                        border: `1px solid ${metric.color}`,
                                        '& svg': {
                                            transform: 'rotate(10deg)',
                                            transition: 'transform 0.3s ease-in-out',
                                        },
                                    },
                                    '& svg': {
                                        transition: 'transform 0.3s ease-in-out',
                                    },
                                }}
                            >
                                <CardContent sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: 2,
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}>
                                    <Box>
                                        <Typography variant="h6" sx={{ color: metric.labelColor }}>
                                            {metric.label}
                                        </Typography>
                                        <Typography variant="h4" fontWeight="bold" sx={{ fontSize: '2.5rem', color: metric.countColor }}>
                                            {metric.count}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ '& .MuiSvgIcon-root': { fontSize: 50, color: metric.color } }}>
                                        {metric.icon}
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'start', alignItems: 'center', gap: 2 }}>
                    <FormControl variant='outlined' sx={{ minWidth: 180 }}>
                        <InputLabel>Status</InputLabel>
                        <Select
                            value={selectedStatus}
                            label="Status"
                            onChange={handleFilterChange}
                        >
                            {allStatuses.map((status, index) => (
                                <MenuItem key={index} value={status.value}>
                                    {status.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl variant='outlined' sx={{ minWidth: 180 }}>
                        <InputLabel>Submitted for Review</InputLabel>
                        <Select
                            value={submittedForReview}
                            onChange={handleSubmittedForReviewChange}
                            label='Submitted For Review'
                        >
                            <MenuItem value='all'>All</MenuItem>
                            <MenuItem value='true'>Yes</MenuItem>
                            <MenuItem value='false'>No</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <Box sx={{ mt: 4 }}>
                    <TableContainer component={Paper} sx={{ minWidth: '100px' }}>
                        <Table sx={{ minWidth: 400 }}>
                            <TableHead>
                                <TableRow sx={{
                                    background: 'linear-gradient(to right, #a8fdf5, #fff)',
                                }}>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Task sx={{ mr: 1, color: 'primary.main' }} />
                                            Task Name
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <Work sx={{ mr: 1, color: 'primary.main' }} />
                                            Project Name
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <EventIcon sx={{ mr: 1, color: 'error.main' }} />
                                            Deadline
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <AccessTimeIcon sx={{ mr: 1, color: 'info.main' }} />
                                            Estimated Hours
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <AccessTimeIcon sx={{ mr: 1, color: 'success.main' }} />
                                            Actual Hours
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <PriorityHighIcon sx={{ mr: 1, color: 'warning.main' }} />
                                            Priority
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold', display: isLargeScreen ? 'table-cell' : 'none' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <InfoIcon sx={{ mr: 1, color: 'info.main' }} />
                                            Status
                                        </Box>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <TaskIcon sx={{ mr: 1, color: 'success.main' }} />
                                            Review
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tasks.length > 0 ? (
                                    tasks.map((task, index) => (
                                        <TableRow
                                            key={index}
                                            onClick={() => handleTaskDetailsClick(task.task_id)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <TableCell sx={{ fontWeight: '600', fontSize: '14px', wordWrap: 'break-word' }}>
                                                {task.task_title}
                                            </TableCell>
                                            <TableCell sx={{ fontWeight: '600', fontSize: '13px', wordWrap: 'break-word' }}>
                                                {task.project_name}
                                            </TableCell>
                                            <TableCell>{new Date(task.due_date).toLocaleDateString()}</TableCell>
                                            <TableCell>{formatTime(task.estimated_hours)}</TableCell>
                                            <TableCell>{formatTime(task.actual_hours)}</TableCell>
                                            <TableCell>
                                                <Chip
                                                    label={task.priority}
                                                    sx={{
                                                        backgroundColor: priorityBackgroundColors[task.priority] || 'rgba(158, 158, 158, 0.1)',
                                                        color: priorityTextColors[task.priority] || '#757575',
                                                        fontWeight: 'bold',
                                                        border: `1px solid ${priorityTextColors[task.priority]}20`,
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell sx={{ display: isLargeScreen ? 'table-cell' : 'none' }}>
                                                <Chip
                                                    label={task.status}
                                                    sx={{
                                                        backgroundColor: statusBackgroundColors[task.status] || 'rgba(158, 158, 158, 0.1)',
                                                        color: statusTextColors[task.status] || '#757575',
                                                        fontWeight: 'bold',
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell>
                                                <IconButton>
                                                    <CheckCircleIcon style={{ color: task.submit_for_review ? '#FFBF00' : 'grey' }} />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">
                                            No tasks found
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        backgroundColor: '#f8fafc',
                        borderTop: '1px solid #e2e8f0',
                        p: 2,
                        gap: 2
                    }}>
                        <FormControl size="small" sx={{ minWidth: 120 }}>
                            <InputLabel>Rows per page</InputLabel>
                            <Select
                                value={rowsPerPage}
                                onChange={handleRowsPerPageChange}
                                label="Rows per page"
                            >
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={25}>25</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                            </Select>
                        </FormControl>
                        {pagination.totalPages >= 1 && (
                            <Pagination
                                count={pagination.totalPages}
                                page={pagination.page}
                                onChange={handlePageChange}
                                color="primary"
                                sx={{
                                    '& .MuiPaginationItem-root': {
                                        borderRadius: '8px',
                                        '&.Mui-selected': {
                                            backgroundColor: '#1976D2',
                                            color: 'white',
                                            '&:hover': {
                                                backgroundColor: '#115293',
                                            }
                                        },
                                        '&:not(.Mui-selected):hover': {
                                            backgroundColor: 'rgba(99, 102, 241, 0.1)',
                                        }
                                    }
                                }}
                            />
                        )}
                    </Box>
                </Box>

                <Modal open={isTaskDetailsOpen} onClose={handleCloseTaskDetails}>
                    <Box
                        sx={{
                            maxWidth: { lg: '80vw', xs: '100vw' },
                            maxHeight: '100vh',
                            display: 'flex',
                            flexDirection: 'column',
                            margin: 'auto',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: 3,
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                            zIndex: "100"
                        }}
                    >
                        <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>
                            <TaskDetails onClose={handleCloseTaskDetails} taskId={selectedTask} />
                        </Box>
                        <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', textAlign: 'right' }}>
                            <Button variant="outlined" color="primary" onClick={handleCloseTaskDetails}>
                                CLOSE
                            </Button>
                        </Box>
                    </Box>
                </Modal>

                <Modal
                    open={openTokenExpirePopup}
                    onClose={handleCloseTokenExpirePopup}
                >
                    <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
                </Modal>

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={6000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                >
                    <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </Box>
        </>
    );
};

export default MyTasks;